class FeatureSliderService {
    constructor(slider) {
        this.slider = slider;
        this.currentSlideIndex = 0;
        this.featureCards = Array.from(slider.querySelectorAll('.c-feature-card'));
        this.featureSlideContainer = slider.querySelector('.c-feature-cards');
        this.previewCardsContainer = slider.querySelector('.c-preview-cards');
        this.previewCards = Array.from(slider.querySelectorAll('.js-preview-card'));
        this.prevButton = slider.querySelector('.js-feature-prev-btn');
        this.nextButton = slider.querySelector('.js-feature-next-btn');
        this.viewAllLink = slider.querySelector('.js-feature-view-all');
        this.survivorFooter = slider.querySelector('.c-survivor-footer');
        this.touchEnabled = slider.dataset.touchEnabled !== "false";

        this.handleScroll = this.handleScroll.bind(this);

        this.touchStartX = 0;
        this.touchStartTime = 0;
        this.touchMoveX = 0;

        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.handleSlideNavigation = this.handleSlideNavigation.bind(this);

        this.init();
    }

    init() {
        this.setupScrollableContainer();
        this.addEventListeners();
        this.updateNavigationButtons();
        this.addScrollListener();
    }

    addEventListeners() {
        if (this.featureSlideContainer && this.touchEnabled) {
            this.featureSlideContainer.addEventListener('touchstart', this.handleTouchStart, { passive: true });
            this.featureSlideContainer.addEventListener('touchmove', this.handleTouchMove, { passive: true });
            this.featureSlideContainer.addEventListener('touchend', this.handleTouchEnd);
        }

        this.slider.addEventListener('click', this.handleSlideNavigation);
    }

    setupScrollableContainer() {
        if (this.featureSlideContainer) {
            this.featureSlideContainer.style.display = 'flex';
            this.featureSlideContainer.style.overflowX = 'auto';
            this.featureSlideContainer.style.scrollSnapType = 'x mandatory';
            this.featureSlideContainer.style.scrollBehavior = 'smooth';
            this.featureSlideContainer.style.webkitOverflowScrolling = 'touch';

            this.featureCards.forEach(card => {
                card.style.flex = '0 0 100%';
                card.style.scrollSnapAlign = 'start';
            });
        }
    }

    addScrollListener() {
        if (this.featureSlideContainer) {
            this.featureSlideContainer.addEventListener('scroll', this.handleScroll, { passive: true });
        }
    }

    handleScroll() {
        const scrollPosition = this.featureSlideContainer.scrollLeft;
        const cardWidth = this.featureCards[0].offsetWidth;
        const newIndex = Math.round(scrollPosition / cardWidth);

        if (newIndex !== this.currentSlideIndex) {
            this.currentSlideIndex = newIndex;
            this.updateActiveClasses();
            this.updateNavigationButtons();
            this.updatePreviewCardsPosition();
        }
    }

    handleTouchStart(e) {
        this.touchStartX = e.touches[0].clientX;
        this.touchStartTime = Date.now();
    }

    handleTouchMove(e) {
        this.touchMoveX = e.touches[0].clientX;
    }

    handleTouchEnd() {
        const threshold = 50;
        const timeThreshold = 200;
        const touchDelta = this.touchStartX - this.touchMoveX;
        const touchTime = Date.now() - this.touchStartTime;

        if (Math.abs(touchDelta) <= threshold || touchTime <= timeThreshold) {
            return;
        }

        if (touchDelta > 0 && this.currentSlideIndex < this.previewCards.length - 1) {
            this.currentSlideIndex++;
        }

        if (touchDelta < 0 && this.currentSlideIndex > 0) {
            this.currentSlideIndex--;
        }

        this.updateSlider();
    }

    updateActiveClasses() {
        this.featureCards.forEach((featureCard, index) => {
            featureCard.classList.toggle('is-active', index === this.currentSlideIndex);
        });
        this.previewCards.forEach((previewCard, index) => {
            previewCard.classList.toggle('is-active', index === this.currentSlideIndex);
        });
    }

    updateSlidePosition() {
        if (this.featureSlideContainer) {
            this.featureSlideContainer.scrollTo({
                left: this.currentSlideIndex * this.featureCards[0].offsetWidth,
                behavior: 'smooth'
            });
        }
        this.updatePreviewCardsPosition();
    }

    updatePreviewCardsPosition() {
        const scrollLeft = this.currentSlideIndex * this.previewCards[0].offsetWidth;
        requestAnimationFrame(() => {
            this.previewCardsContainer.style.scrollBehavior = 'smooth';
            this.previewCardsContainer.scrollLeft = scrollLeft;
        });
    }

    updateNavigationButtons() {
        if (this.prevButton && this.nextButton) {
            this.prevButton.disabled = this.currentSlideIndex === 0;
            this.nextButton.disabled = this.currentSlideIndex === this.previewCards.length - 1;

            if (this.viewAllLink) {
                this.viewAllLink.classList.toggle('c-display-none', !(this.currentSlideIndex === this.previewCards.length - 1));
            }

            this.nextButton.classList.toggle('c-display-none', this.currentSlideIndex === this.previewCards.length - 1);

        }

        if (this.survivorFooter) {
            this.survivorFooter.classList.toggle('is-active', this.currentSlideIndex === this.previewCards.length - 1);
        }
    }

    updateSlider() {
        this.updateActiveClasses();
        this.updateSlidePosition();
        this.updateNavigationButtons();
    }

    handleSlideNavigation(e) {
        if (e.target.closest('.js-feature-prev-btn') === this.prevButton && this.currentSlideIndex > 0) {
            this.currentSlideIndex--;
            this.updateSlider();
            return;
        }

        if (e.target.closest('.js-feature-next-btn') === this.nextButton && this.currentSlideIndex < this.previewCards.length - 1) {
            this.currentSlideIndex++;
            this.updateSlider();
            return;
        }

        if (e.target.closest('.c-preview-card')) {
            const clickedPreviewCard = e.target.closest('.c-preview-card');
            this.currentSlideIndex = this.previewCards.indexOf(clickedPreviewCard);
            this.updateSlider();
            return;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.js-feature-slider--woh');
    if (sliders.length === 0) return;

    sliders.forEach(slider => {
        new FeatureSliderService(slider);
    });
});
